<template>
  <div class="hr-container">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'HotelManagementReservationsIndex',
}
</script>